<template>
  <div class="pushorderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"> 
    <div style="height:15px"></div>
    <!--<div class="header">
      <div class="bg" :style="'background:url('+bg+');background-size:100% 100%;'">
        <div class="headCon">
          <img :src="userData.avatar" />
          <p>{{userData.username}}<b>加入时间：{{userData.createtime}}</b></p>
        </div>
      </div>
      <div class="info">
        <div class="item-list" @click="toPush1(1,id,'pushStaff')">
          <p>{{setTotal.wx}}</p>
          <p>微信剩余</p>
        </div>
        <div class="item-list" @click="toPush1(2,id,'pushStaff')">
          <p>{{setTotal.dx}}</p>
          <p>短信剩余</p>
        </div>-
        <div class="item-list" @click="toPush1(3,id,'pushStaff')">
          <p>{{setTotal.pt}}</p>
          <p>平台通知</p>
        </div>
      </div>
    </div>-->
    <div class="order-item" v-for="(item,i) in order">
      <div class="title">
        <div class="address">{{item.username}}<font>({{item.zt == 1 ? '有效中' : '已过期'}})</font></div>
        <div class="make" @click="toPush1(item.message_id,id,'batch')">批量推送<font class="el-icon-arrow-right"></font></div>
      </div>
      <div class="product">
        <div class="left">
          <div class="names">
            <div class="bt">{{item.title}}<span>×{{item.total}}</span></div>
            <div class="timer">使用时间：{{item.starttime}} 至 {{item.endtime}}</div>
            <div class="timer">购买时间：{{item.createtime}}</div>
            <div class="timer" >订单编号：{{item.munber}}
              <span><i>￥</i><b>{{item.price.split(".")[0]}}</b>
              <i>.{{item.price.split(".")[1]}}</i></span>
            </div>
          </div>
        </div>
      <div class="rylcjs" @click="toPush(item.id,'pushScenic')">查看选中的景区 <img src="~assets/images/icon5.png"></div>
      </div>
    </div>  
    <div class="none"  v-if="order.length <= 0 ">
      <img src="~assets/images/no.png">
    </div>

  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        userData:[],
        order:[],
        curHeight:0,
        fullscreenLoading: true,
        baseUrl:'',
        bg:require( '../../assets/images/lock_bg.png'),
        id:0,
        setTotal:[]
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getOrder();
      this.getTotal();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        var id = this.$route.query.id;
        this.id = id;
      },  
      backTop:function(){
        const that = this;
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
      },
      getOrder:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/message/order',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          that.order = res
          
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      getTotal:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/message/orderTotal',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          that.setTotal = res
          
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      toPush1:function(index,id,url){
        this.$router.push({
          path:url,
          query:{
            id:index,
            mall_id:id,
          }
        })
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-message{
    top:auto !important;
    bottom:20px !important;
    min-width:70% !important;
  }
  .pushorderApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .pushorderApp .header{
    width:92%;
    height:160px;
    display:block;
    margin:0 auto;
    background:#fff;
    background: #FFFFFF;
    border-radius: 10px;
  }
  .pushorderApp .header .bg{
    width: 100%;
    height: 100px;
    position: relative;
  }
  .pushorderApp .header .bg .headCon img{
    margin:15px 0 0 16px;
    padding:2px;
    float:left;
    background:#fff;
    width:70px;
    border-radius: 50%;
  }
  .pushorderApp .header .bg .headCon p{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFEFE;
    float:left;
    margin:20px 0 0 10px;
    width:70%
  }
  .pushorderApp .header .bg .headCon p b{
    display:block;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFEFE;
    padding-top:10px;
  }

  .pushorderApp .header .info{
    width: 100%;
    height:58px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .pushorderApp .header .info .item-list{
    width:50%;
    text-align:center;
    position: relative;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #96BBFF;
  }
  .pushorderApp .header .info .item-list p:first-child{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #2F78FF;
    padding:10px 0 2px 0
  }
  .pushorderApp .header .info .item-list:after{
    position: absolute;
    width:1px;
    height:40px;
    content:'';
    right:0;
    top:9px;
    background:#EBF2FF
  }

  .pushorderApp .order-item{
    width: 92%;
    display: block;
    margin: 0px auto 15px auto;
    background: #FFFFFF;
    border-radius: 4px;
  }
  .pushorderApp .order-item .title{
    height: 50px;
    display: block;
    line-height: 51px;
    border-bottom:solid 1px #EBF2FF;
    width:90%;
    margin:0 auto;
  }
  .pushorderApp .order-item .title .address{
    float: left;
    font-size: 16px;
    font-weight:bold;
  }
  .pushorderApp .order-item .title .address font{
    font-weight:normal;
    color:#406DE1;
    font-size:14px;
    padding-left:10px
  }
  .pushorderApp .order-item .title .make{
    float:right;
    font-size:14px;
    color:#f00
  }
  .pushorderApp .order-item .product .left:after,.pushorderApp .order-item .btn:after{
    display:block;
    clear:both;
    content:"";
    visibility:hidden;
    height:0
  } 
  .pushorderApp .order-item .product .left .names{
    float:left;
    margin-left:4%;
    position:relative;
    width:96%;
  }
  .pushorderApp .order-item .product .left .names .bt{
    font-size: 15px;
    color: #000;
    width: 100%;
    height:45px;
    line-height: 45px;
  }
  .pushorderApp .order-item .product .left .names .bt span{
    float:right;
    color:#666;
    margin-right:15px;
    font-size:16px;
  }
  .pushorderApp .order-item .product .left .names .timer{
    font-size: 14px;
    color: #999;
    padding-bottom:10px;
  }
  .pushorderApp .order-item .product .left .names .timer span{
    float:right;
    color:#FF6600;
    margin-right:15px;
    font-size:16px;
    margin-top:-5px;
    font-weight:bold
  }
  .pushorderApp .order-item .product .left .names .timer span b{
    color: #FF6600;
    font-size:17px;
    font-weight:500;
  }

  .pushorderApp .order-item .product .left .names .timer span i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }
  .pushorderApp .none{
    text-align:center;
    padding-top:50%
  }
  .pushorderApp .none img{
    width:90%;
    display:block;
    margin:0 auto;
  }

  .pushorderApp .rylcjs{
    width:92%;
    margin:0 auto;
    height:40px;
    line-height:40px;
    border-top:solid 1px #ebebeb;
    margin-top:10px;
    font-size:15px;
    color:#666
  }
  .pushorderApp .rylcjs img{
    float:right;
    width:8px;
    margin-top:14px
  }

</style>